import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import { VirtualizedTableColumnKeys } from 'services/virtualizedTable/types';
import { selectVirtualizedTableColumnKeys } from 'services/virtualizedTable/selectors';

import { VirtualizedTableContextProviderValue } from '../../types';
import {
    ROW_HEIGHT,
    SELECT_COLUMN_WIDTH,
    EXPAND_COLUMN_WIDTH,
    FILLER_COLUMN_WIDTH
} from '../../constants';
import { useVirtualizedTableContext } from '../VirtualizedTableContext';
import VirtualizedTableFooterColumn from '../VirtualizedTableFooterColumn';

interface OwnProps {
    tableHeight?: number | undefined;
}

interface ConnectedProps {
    columnKeys: VirtualizedTableColumnKeys;
}

type Props = OwnProps & ConnectedProps;

export const VirtualizedTableFooterComponent = (
    props: Props
): React.ReactElement | null => {
    const { tableHeight = 0, columnKeys } = props;

    const {
        selectable,
        onExpand,
        enableItemEditing,
        height = 0,
        enableFooter
    }: VirtualizedTableContextProviderValue = useVirtualizedTableContext();

    const isTableScrollable = tableHeight > height;

    const isExpandable = onExpand || enableItemEditing;

    if (!enableFooter) {
        return null;
    }

    return (
        <div
            className="virtualized-table-footer"
            style={{
                height: ROW_HEIGHT,
                top: height - ROW_HEIGHT,
                ...(isTableScrollable
                    ? {
                          position: 'sticky'
                      }
                    : {
                          position: 'absolute',
                          minWidth: '100%'
                      })
            }}
        >
            <div className="virtualized-table-footer-row">
                {selectable && (
                    <div
                        className="virtualized-table-footer-cell"
                        style={{
                            width: SELECT_COLUMN_WIDTH,
                            height: ROW_HEIGHT
                        }}
                    />
                )}
                {isExpandable && (
                    <div
                        className="virtualized-table-footer-cell"
                        style={{
                            width: EXPAND_COLUMN_WIDTH,
                            height: ROW_HEIGHT
                        }}
                    />
                )}
                {columnKeys &&
                    columnKeys.map((columnKey) => (
                        <VirtualizedTableFooterColumn
                            key={columnKey}
                            columnKey={columnKey}
                        />
                    ))}
                <div
                    className="virtualized-table-footer-cell"
                    style={{
                        width: FILLER_COLUMN_WIDTH,
                        height: ROW_HEIGHT
                    }}
                />
            </div>
        </div>
    );
};

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    columnKeys: selectVirtualizedTableColumnKeys
});

export default connect(mapStateToProps)(VirtualizedTableFooterComponent);
